/**
 * Chuỗi của màn Danh sách Project (`/rpa/projects`) và Danh sách luồng (`/rpa/workflows`) — namespace
 * `rpa.projects`, `rpa.workflowList` của web-portal native, đổi sang kiểu dấu thanh mới; bỏ phần License (đợt sau).
 * Tạm tách tệp, sẽ gộp vào `vi.ts`.
 */
export const viRpaWorkflow = {
  rpaProject: {
    moTa: 'Project OpenRPA đang có trên OpenCore và Workflow trong từng Project.',
    tongProject: 'Tổng Project',
    tongProjectSub: 'Project trên OpenCore',
    tongWorkflow: 'Tổng Workflow',
    tongWorkflowSub: 'Workflow thuộc các Project',
    tim: 'Tìm Project / Workflow...',
    xuatCsv: 'Xuất CSV',
    daXuat: 'Đã xuất danh sách Project.',
    daLamMoi: 'Đã tải lại danh sách Project từ OpenCore.',
    rong: 'Chưa có Project nào trên OpenCore',
    rongMoTa: 'Tạo Project trong OpenRPA Designer rồi bấm Làm mới.',
    rongLoc: 'Không có Project nào khớp từ khoá',
    cotTen: 'Project',
    cotWorkflow: 'Workflow',
    cotCapNhat: 'Cập nhật',
    chuaCoWorkflow: 'Chưa có Workflow',
    themWorkflow: '+{{so}} workflow',
    xemChiTiet: 'Xem chi tiết',
    xemChiTietCua: 'Xem chi tiết {{ten}}',
    csvTen: 'Project',
    csvId: 'ID OpenCore',
    csvWorkflow: 'Workflow',
    csvCapNhat: 'Cập nhật',
    hopTieuDe: 'Chi tiết Project · {{ten}}',
    hopMeta: 'ID OpenCore: {{id}} · cập nhật {{luc}}',
    hopWorkflow: 'Workflow trong Project ({{so}})',
    hopCotWorkflow: 'Workflow',
    hopCotId: 'ID OpenCore',
    hopCotCapNhat: 'Cập nhật',
    hopRong: 'Project chưa có Workflow nào trên OpenCore.',
    userCoLicense: 'User đang có License',
    licenseKhongTai: 'Không tải được License',
    licenseSapHet: 'License sắp hết hạn',
    licenseSapHetSub: 'Trong {{so}} ngày tới',
    cotUserCap: 'User được cấp',
    hopCotUser: 'User được dùng',
    hopChuaCap: 'Chưa cấp cho ai',
    hopLicense: 'User được cấp License ({{so}})',
    hopChuaCoLicense: 'Chưa có User nào được cấp License trong Project này',
    hopChuaCoLicenseMoTa: 'Cấp ở màn Quản lý License RPA: chọn Project rồi chọn Workflow cho User.',
    hopCotUserLicense: 'User',
    hopCotLoai: 'Loại',
    hopCotPhamVi: 'Workflow được dùng',
    hopCotTrangThai: 'Trạng thái',
    hopCotHetHan: 'Hết hạn',
  },
  rpaWorkflow: {
    moTa: 'Chọn một Workflow để xem các bước, biến & tham số và thông tin chi tiết.',
    loai: {
      openrpa: 'OpenRPA',
      script: 'Script / API',
      openrpaTieuDe: 'Luồng thao tác như con người (OpenRPA)',
      scriptTieuDe: 'Luồng tự động bằng Script / API',
      openrpaMoTa:
        'Mô phỏng thao tác người dùng trên giao diện, phù hợp website có anti-bot / CAPTCHA / cần click nhập liệu như người thật.',
      scriptMoTa: 'Xử lý trực tiếp qua API, script hoặc headless, phù hợp tác vụ nhanh, ổn định, data-driven.',
    },
    dangDung: 'luồng đang sử dụng',
    tim: 'Tìm Workflow hoặc Project...',
    locProject: 'Lọc theo Project',
    tatCaProject: 'Tất cả Project',
    khongThuocProject: 'Không thuộc Project',
    thuocProject: 'Project: {{ten}}',
    rong: 'Chưa có Workflow nào trên OpenCore',
    rongMoTa: 'Workflow publish từ OpenRPA sẽ hiện ở đây.',
    rongLoc: 'Không có Workflow phù hợp',
    xemBuoc: 'Xem các bước',
    xemThongTin: 'Xem thông tin',
    chonWorkflow: 'Chọn một Workflow ở cột bên trái',
    chonWorkflowMoTa: 'Các bước, tham số và biến của Workflow sẽ hiện ở đây.',
    loaiLuong: 'Loại luồng',
    catBot: 'Workflow quá lớn: chỉ hiện {{so}} bước đầu tiên.',
    soBuoc: '{{so}} bước',
    hienBuoc: 'Hiện các bước',
    anBuoc: 'Ẩn các bước',
    chuaCoBuoc: 'Workflow chưa có bước.',
    danhSachBuoc: 'Các bước của {{ten}}',
    moWorkflowCon: 'Mở Workflow con',
    tabThuocTinh: 'Thuộc tính bước',
    tabGiaTri: 'Biến & tham số',
    tabThongTin: 'Thông tin',
    chonBuoc: 'Chọn một bước trong danh sách bước để xem thuộc tính.',
    tenBuoc: 'Tên bước',
    loaiActivity: 'Loại activity',
    maBuoc: 'Mã bước (IdRef)',
    workflowCon: 'Workflow con',
    cotThuocTinh: 'Thuộc tính',
    cotGiaTri: 'Giá trị',
    captionThuocTinh: 'Thuộc tính của bước {{ten}}',
    khongThuocTinh: 'Bước này không có thuộc tính nào được đặt.',
    ttTen: 'Tên Workflow',
    ttProject: 'Project',
    ttCapNhat: 'Cập nhật',
    ttId: 'Workflow ID',
    ttNguoiCapNhat: 'Người cập nhật',
    ttMoTa: 'Mô tả',
    ttSoBuoc: 'Số bước',
    ttCon: 'Workflow con được gọi',
  },
  rpaGiaTri: {
    tim: 'Tìm tên biến, tham số hoặc khối',
    locLoai: 'Lọc theo loại',
    tatCaLoai: 'Tất cả loại',
    thamSo: 'Tham số',
    bien: 'Biến',
    huongIn: 'Tham số vào',
    huongOut: 'Tham số ra',
    huongInOut: 'Tham số vào/ra',
    huongProperty: 'Thuộc tính',
    chiCoGiaTri: 'Chỉ mục có giá trị',
    lichSu: 'Lịch sử sửa',
    hoanTac: 'Hoàn tác',
    luuSo: 'Lưu {{so}} thay đổi',
    cotTen: 'Tên',
    cotLoai: 'Loại',
    cotKieu: 'Kiểu',
    cotGiaTri: 'Giá trị mặc định',
    caption: 'Biến và tham số của {{ten}}',
    trong: 'Trong: {{pham}}',
    daSua: 'Đã sửa',
    khongDat: 'Không đặt',
    biMatGiu: 'Đã có giá trị, để trống để giữ',
    biMatTrong: 'Chưa có giá trị',
    biMatMoi: 'giá trị mới (ẩn)',
    loiBoolean: 'Chỉ nhận True hoặc False.',
    loiInteger: 'Phải là số nguyên.',
    loiNumber: 'Phải là số, dùng dấu chấm cho phần thập phân.',
    lyDoEXPRESSION: 'Biểu thức, sửa bằng OpenRPA Designer',
    lyDoTYPE: 'Kiểu này sửa bằng OpenRPA Designer',
    lyDoOUT_ARGUMENT: 'Tham số ra, không có giá trị mặc định',
    lyDoCOMPLEX: 'Sửa bằng OpenRPA Designer',
    rong: 'Workflow này không có biến hay tham số nào',
    rongLoc: 'Không có mục nào khớp bộ lọc',
    xacNhanTieuDe: 'Lưu {{so}} thay đổi vào Workflow?',
    xacNhanThan:
      'Robot dùng giá trị mới từ lượt chạy kế tiếp. Bản hiện tại được lưu lại, khôi phục được ở Lịch sử sửa.',
    luuVao: 'Lưu vào Workflow',
    daLuu: 'Đã lưu {{so}} thay đổi vào Workflow.',
    lichSuTieuDe: 'Lịch sử sửa biến & tham số',
    lichSuRong: 'Chưa có lần sửa nào từ Native',
    banLuu: {
      edit: 'Sửa',
      restore: 'Khôi phục',
    },
    khoiPhucTu: 'Khôi phục về bản lúc {{luc}}',
    khoiPhucTruoc: 'Khôi phục về trước lần này',
    khoiPhucHoi: 'Đưa Workflow về bản trước lần sửa lúc {{luc}}? Giá trị hiện tại vẫn được lưu lại trong lịch sử.',
    khoiPhuc: 'Khôi phục Workflow',
    daKhoiPhuc: 'Đã khôi phục Workflow.',
  },
  rpaChay: {
    batDau: 'Bắt đầu',
    dangChay: 'Đang chạy',
    dangChayTren: 'Robot {{robot}} đang chạy Workflow này',
    chonProjectTieuDe: 'Chạy Workflow {{ten}}',
    chonProjectMoTa: 'Workflow này được phép chạy ở nhiều Project. Chọn Project chạy:',
    project: 'Project chạy',
    chonProject: 'Chọn Project',
    chay: 'Chạy Workflow',
    khongCoProject: 'Chưa có Project được phép chạy Workflow này với License hợp lệ cho Robot.',
    xong: 'Workflow {{ten}} đã chạy xong.',
    loi: 'Workflow {{ten}} chạy lỗi. Xem chi tiết ở Lịch sử luồng chạy.',
    matDau: 'Chưa nhận được kết quả của Workflow {{ten}}. Xem trạng thái ở Lịch sử luồng chạy.',
    ketNoi: 'Kết nối OpenCore',
    hopTieuDe: 'Kết nối tài khoản OpenCore',
    taiKhoan: 'Tài khoản OpenCore',
    matKhau: 'Mật khẩu',
    ghiChu: 'Dùng tài khoản đang đăng nhập OpenRPA trên máy Robot. Native không lưu mật khẩu.',
    nutKetNoi: 'Kết nối',
    daKetNoi: 'Đã kết nối tài khoản OpenCore {{ten}}.',
    taiKhoanDangKetNoi: 'Tài khoản OpenCore đang kết nối: {{ten}}',
    chayTren: 'Chạy trên Robot {{ten}} · {{trangThai}}',
    online: 'đang online',
    offline: 'đang offline',
    chuaRo: 'chưa rõ trạng thái',
    hetHan: 'kết nối đã hết hạn',
    ketNoiLai: '{{ten}} · kết nối lại',
    doiTaiKhoan: 'Đổi tài khoản',
    dangXuat: 'Đăng xuất',
    daDangXuat: 'Đã đăng xuất tài khoản OpenCore.',
  },
} as const;
